import { ref } from '@vue/reactivity'
// @ts-ignore
import { onMounted, onUnmounted } from 'vue'

/** Breakpoint (px) below which the app is considered a mobile viewport. */
export const MOBILE_BREAKPOINT = 768

/**
 * Reactive composable that tracks whether the current viewport is considered
 * "mobile" (width < MOBILE_BREAKPOINT). The value updates on window resize.
 */
export function useIsMobile() {
  const isMobile = ref(
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  )

  const onResize = () => {
    isMobile.value = window.innerWidth < MOBILE_BREAKPOINT
  }

  onMounted(() => {
    window.addEventListener('resize', onResize)
    // Re-check immediately in case it changed before mount
    isMobile.value = window.innerWidth < MOBILE_BREAKPOINT
  })

  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
  })

  return { isMobile }
}
